export const NEW_LOAN_IN_PROGRESS_WIDGETS = ['status_tracker_widget', 'doc_upload_widget', 'disclosure_widget', 'loan-in-progress-task'];
